// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "@37signals/lexxy"
import "./controllers"

// Our <lexxy-toolbar> sits inside <lexxy-editor>. HTML that arrives inert (a
// Turbo visit's body, a stream's template) is upgraded in tree order as it is
// inserted, so the editor connects before its toolbar is upgraded and Lexxy
// throws "setEditor is not a function". Upgrading the toolbar when the editor
// asks for it keeps the order a full page load has, however the HTML arrived.
// Lexxy defines its elements on a timeout, hence whenDefined. Until
// basecamp/lexxy#496 is released; see
// documentation/development_manual/school-texts.md.
customElements.whenDefined("lexxy-editor").then((LexxyEditor) => {
  const toolbarElement = Object.getOwnPropertyDescriptor(LexxyEditor.prototype, "toolbarElement")
  Object.defineProperty(LexxyEditor.prototype, "toolbarElement", {
    ...toolbarElement,
    get() {
      const toolbar = toolbarElement.get.call(this)
      if (toolbar) customElements.upgrade(toolbar)
      return toolbar
    }
  })
})
